import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { serverAddress } from "../../../constants";

const PublicDocumentViewer = () => {
  const { uuid } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(
          `${serverAddress}/jobOrder/document/public/documents/${uuid}`
        );
        setData(response.data);
      } catch (err) {
        setError("Unable to load documents. The link may be invalid or expired.");
      } finally {
        setLoading(false);
      }
    };

    if (uuid) {
      fetchDocuments();
    }
  }, [uuid]);

  return (
    <div style={{ minHeight: "100vh", background: "#f5f7fa", padding: "40px 20px" }}>
      <div style={{ maxWidth: 600, margin: "0 auto", background: "#fff", borderRadius: 8, boxShadow: "0 2px 12px rgba(0,0,0,0.1)", overflow: "hidden" }}>
        {/* Header */}
        <div style={{ background: "#1a3c6b", padding: "20px 28px", display: "flex", alignItems: "center", gap: 16 }}>
          <div>
            <h2 style={{ color: "#fff", margin: 0, fontSize: 18 }}>Powertech India</h2>
            <p style={{ color: "#b0c4de", margin: "4px 0 0", fontSize: 12 }}>Dispatch Document Viewer</p>
          </div>
        </div>

        <div style={{ padding: "28px" }}>
          {loading && (
            <div style={{ textAlign: "center", padding: "40px 0" }}>
              <ClipLoader color="#1a3c6b" loading={loading} size={40} />
              <p style={{ marginTop: 12, color: "#666" }}>Loading documents...</p>
            </div>
          )}

          {error && (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#c0392b" }}>
              <i className="fas fa-exclamation-circle" style={{ fontSize: 32, marginBottom: 12, display: "block" }} />
              <p>{error}</p>
            </div>
          )}

          {data && (
            <>
              {/* Job Details */}
              <div style={{ marginBottom: 24 }}>
                <h5 style={{ color: "#1a3c6b", borderBottom: "2px solid #1a3c6b", paddingBottom: 6, marginBottom: 12 }}>
                  Job Details
                </h5>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: "5px 0", fontWeight: "bold", color: "#444", width: "45%" }}>Job / PO Number</td>
                      <td style={{ padding: "5px 0", color: "#222" }}>{data.job_number}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: "5px 0", fontWeight: "bold", color: "#444" }}>Customer Name</td>
                      <td style={{ padding: "5px 0", color: "#222" }}>{data.customer_name}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Documents */}
              <div>
                <h5 style={{ color: "#1a3c6b", borderBottom: "2px solid #1a3c6b", paddingBottom: 6, marginBottom: 12 }}>
                  Dispatch Documents
                </h5>
                {data.documents && data.documents.length > 0 ? (
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {data.documents.map((doc, index) => (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px 12px",
                          marginBottom: 8,
                          background: "#f0f4f8",
                          borderRadius: 6,
                          borderLeft: "4px solid #1a3c6b",
                        }}
                      >
                        <span style={{ color: "#222", fontSize: 13 }}>
                          <i className="fas fa-file-alt" style={{ marginRight: 8, color: "#1a3c6b" }} />
                          {doc.document_name}
                        </span>
                        {doc.signedUrl ? (
                          <a
                            href={doc.signedUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              background: "#1a3c6b",
                              color: "#fff",
                              padding: "5px 12px",
                              borderRadius: 4,
                              textDecoration: "none",
                              fontSize: 12,
                              whiteSpace: "nowrap",
                            }}
                          >
                            <i className="fas fa-download" style={{ marginRight: 4 }} />
                            View
                          </a>
                        ) : (
                          <span style={{ color: "#999", fontSize: 12 }}>Unavailable</span>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p style={{ color: "#666" }}>No documents available.</p>
                )}
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{ background: "#f0f4f8", padding: "12px 28px", textAlign: "center", borderTop: "1px solid #dde3ea" }}>
          <p style={{ margin: 0, fontSize: 11, color: "#888" }}>
            This is a read-only view generated by Powertech India ERP.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PublicDocumentViewer;
